import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeOneComponent } from './components/home-one/home-one.component';
import { BlogDetailsComponent } from './components/blog-details/blog-details.component';
import { RedComponent } from './components/red/red.component';
import { AdminComponent } from './admin/admin.component';

const routes: Routes = [
    {path: '', component: HomeOneComponent},
    {path: 'blog-details', component: BlogDetailsComponent},
    {path: 'red', component: RedComponent},
    {path: 'admin', component: AdminComponent},
    // Here add new pages component

    {path: '**', component: HomeOneComponent} // This line will remain down from the whole pages component list
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' })],
    exports: [RouterModule]
})
export class AppRoutingModule { }